.name-display-container {
  display: contents;
  cursor: default;

  .tooltip-trigger {
    display: contents;
  }
}

.analyst-approver-name-display {
  position: relative;
  display: inline-block;
  width: 100%;
  max-width: 100%;

  &-ellipsis {
    display: inline-block;
    width: 100%;
    max-width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: default;
  }

  .button {
    &-children {
      width: 100% !important;
      font-weight: 400 !important;
      text-align: left !important;
      padding-right: 30px !important;
    }
  }
}

.table-cell:has(.display-user-wrapper) {
  overflow: hidden !important;
}
